export default "__VITE_ASSET__D6jR_$_F__"